import { isPixiesetAuthEnabled } from "@/utils/measurement/feature-flag"
import {
	findExistingFileName,
	isKnownFileName,
	orderPreferredFileNames,
	resolveFileName,
} from "./file-name-resolution"

export const POLARR_CATALOG_FILE_NAME = "polarr.catalog"
export const PIXIESET_CATALOG_FILE_NAME = "pixieset.catalog"
const CATALOG_FILE_NAMES = [POLARR_CATALOG_FILE_NAME, PIXIESET_CATALOG_FILE_NAME] as const

export function getCatalogFileName(url?: URL): string {
	return isPixiesetAuthEnabled(url) ? PIXIESET_CATALOG_FILE_NAME : POLARR_CATALOG_FILE_NAME
}

export function getCatalogFileNamesByPriority(url?: URL): string[] {
	return orderPreferredFileNames(getCatalogFileName(url), CATALOG_FILE_NAMES)
}

export function isCatalogFileName(fileName: string): boolean {
	return isKnownFileName(fileName, CATALOG_FILE_NAMES)
}

export async function findExistingCatalogFileName(
	directory: FileSystemDirectoryHandle,
	url?: URL,
): Promise<string | null> {
	return findExistingFileName(directory, getCatalogFileNamesByPriority(url))
}

export async function resolveCatalogFileName(
	directory: FileSystemDirectoryHandle,
	url?: URL,
): Promise<string> {
	return resolveFileName(directory, getCatalogFileName(url), getCatalogFileNamesByPriority(url))
}
